import React from 'react';
import injectSheet from 'react-jss';
import CheckBox from 'Components/CheckBox';
import styles from './styles';

interface Props {
  list: any;
  classes?: any;
  onClick?: (event: any) => void;
}

const CheckBoxList = (props: Props) => {
  const { classes, list, onClick } = props;

  return (
    <div className={classes.checkBoxGroup}>
      <CheckBox
        label={list.label}
        id={list.id}
        value={list.value}
        isChecked={list.value}
        onClick={onClick}
        overrideStyles={list.overrideStyles}
        ariaControls={list.members.map((item) => item.id).join(' ')}
      />

      <ul>
        {list.members.map((item: any) => (
          <li key={item.id} className={classes.memberCheckBox}>
            <CheckBox
              label={item.label}
              id={item.id}
              value={item.value}
              isChecked={item.value}
              onClick={(e) => props.onClick(e)}
              overrideStyles={item.overrideStyles}
            />
          </li>
        ))}
      </ul>
    </div>
  );
};

CheckBoxList.defaultProps = {
  classes: {},
  onClick: () => {},
};

export default injectSheet(styles)(CheckBoxList);
